import { Sparkles } from "lucide-react";
import AdvisorChat, { CEO_SUGGESTIONS } from "@/components/AdvisorChat";
import { useAuth } from "@/context/AuthContext";

export default function AiCeo() {
  const { user } = useAuth();
  return (
    <div data-testid="ai-ceo-page">
      <AdvisorChat role="ceo" persona={{
        name: "AI CEO", icon: Sparkles, tagline: "Reads your company data, proposes actions, you approve",
        greeting: `How can I help run ${user.company?.name} today?`,
        intro: "I can see your calendar, staff, leave, tasks, goals, finances and marketing. Anything that changes data comes to you as a card to approve.",
        placeholder: "Ask your CEO to schedule, review leave, plan work...", suggestions: CEO_SUGGESTIONS,
      }} />
    </div>
  );
}
